export const generateFileUploadUrl = (baseUrl: string, authToken: string) => {
  return `${baseUrl}/api/file/inlinemailimage?auth=${authToken}`;
};

export const updateTokenFileUploadUrl = (url: string, authToken: string) => {
  const urlObj = new URL(url);
  urlObj.searchParams.set('auth', authToken);
  return urlObj.toString();
};

export const getTokenFromFileUploadUrl = (url: string) => {
  const urlObj = new URL(url);
  return urlObj.searchParams.get('auth');
};
